import { useMemo } from 'react';
import { InputToggleGroup } from '@ui/kit';
import { stringifyGradeLevelRange } from '@utils/constants';
import { wrapperCls, listboxWrapperCls, listboxCls } from './filters.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const ALL_COURSES_COUNTS_OPTIONS = [{
  id: "1-2",
  label: "1 - 2 lektioner"
}, {
  id: "3-6",
  label: "3 - 6 lektioner"
}, {
  id: "7-10",
  label: "7 - 10 lektioner"
}, {
  id: "11-100000",
  label: "10+ lektioner"
}];
function Filters(props) {
  const gradeOptions = useMemo(() => [...new Map(props.cards.flatMap(it => it.meta.grades.map(it => [it.id, it]))).values()].sort((a, b) => a.sortValue - b.sortValue).map(it => ({
    id: it.id,
    label: stringifyGradeLevelRange([it])
  })), [props.cards]);
  const selectedCourseCounts = props.filters.selectedCourseCounts.map(it => {
    return `${it.from}-${it.to}`;
  });
  const availableCoursesCountOptions = useMemo(() => ALL_COURSES_COUNTS_OPTIONS.filter(option => props.cards.some(card => {
    const values = option.id.split("-");
    const from = Number(values[0]);
    const to = Number(values[1]);
    return from <= card.meta.courseCount && card.meta.courseCount <= to;
  })), [props.cards]);
  return /*#__PURE__*/jsxs("section", {
    className: wrapperCls,
    children: [/*#__PURE__*/jsx("div", {
      className: listboxWrapperCls,
      children: /*#__PURE__*/jsx(InputToggleGroup, {
        legend: "Klassetrin",
        className: listboxCls,
        theme: "compact",
        type: "checkbox",
        selectedValues: props.filters.selectedGrades,
        options: gradeOptions,
        toggleValue: value => {
          props.dispatch({
            type: "grade",
            payload: value
          });
        }
      })
    }), /*#__PURE__*/jsx("div", {
      className: listboxWrapperCls,
      children: /*#__PURE__*/jsx(InputToggleGroup, {
        legend: "Antal lektioner",
        theme: "compact",
        className: listboxCls,
        type: "checkbox",
        selectedValues: selectedCourseCounts,
        options: availableCoursesCountOptions,
        toggleValue: id => {
          const values = id.split("-");
          const from = Number(values[0]);
          const to = Number(values[1]);
          props.dispatch({
            type: "course-count",
            payload: {
              from: from,
              to: to
            }
          });
        }
      })
    })]
  });
}

export { Filters };
//# sourceMappingURL=filters.js.map
